import {
  PlayerStatField,
  resolvePlayerStatPayload,
} from "../../components/tournament/playerStatPayload";

type PlayerStatValues = Record<string, unknown>;
type PlayerStatCreateValues = PlayerStatValues & {
  matchId: string;
  playerId: string;
};

const identityFields = ["tournament", "tournamentSeason", "matchNum", "ageCategory"];

const nestedFieldGroups: Record<string, string> = {
  totalPointsWon: "pointsSummary",
  totalPointsLost: "pointsSummary",
  aces: "service",
  serviceFaults: "service",
  doubleFaults: "service",
  winners: "winners",
  smashWinners: "winners",
  netWinners: "winners",
  unforcedErrors: "errorStats",
  forcedErrors: "errorStats",
  rallyPointsWon: "rally",
  longestRally: "rally",
};

const usesNestedStatGroups = (sport: string) =>
  ["tabletennis", "pickleball"].includes(sport.replace(/[\s_-]/g, "").toLowerCase());

export const buildPlayerStatCreatePayload = ({
  matchId,
  playerId,
  ...statValues
}: PlayerStatCreateValues) => ({ matchId, playerId, ...statValues });

export const buildPlayerStatEditPayload = (
  sport: string,
  values: PlayerStatValues,
  fields: ReadonlyArray<PlayerStatField>
) => {
  const identity = identityFields.reduce<Record<string, unknown>>((payload, key) => {
    if (values[key] !== undefined && values[key] !== null && values[key] !== "") {
      payload[key] = values[key];
    }
    return payload;
  }, {});
  const stats = resolvePlayerStatPayload(values, fields);

  if (!usesNestedStatGroups(sport)) {
    return { ...identity, ...stats };
  }

  return Object.entries(stats).reduce<Record<string, unknown>>((payload, [key, value]) => {
    const group = nestedFieldGroups[key];
    if (!group) {
      payload[key] = value;
      return payload;
    }
    payload[group] = { ...(payload[group] as Record<string, unknown> | undefined), [key]: value };
    return payload;
  }, identity);
};
